import React from 'react';

import WsIconProps from './IconProps';

const JDParse: React.FC<WsIconProps> = ({ width = 96, height = 105 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect opacity="0.16" x="1" y="1" width="84" height="105" rx="4" fill="white" />

    <rect x="16" y="17" width="54" height="75" rx="2" fill="white" />

    <rect x="1" y="64" width="84" height="12" fill="url(#paint0_linear_79_91723)" />

    <rect x="23" y="35" width="34" height="5" rx="2" fill="#ADE8F4" />

    <rect x="23" y="47" width="40" height="5" rx="2" fill="#ADE8F4" />

    <rect x="23" y="59" width="27" height="5" rx="2" fill="#ADE8F4" />

    <path d="M1 83.5V102C1 104.209 2.79086 106 5 106H24" stroke="white" strokeLinecap="round" />

    <path d="M1 23.5V5C1 2.79086 2.79086 1 5 1H24" stroke="white" strokeLinecap="round" />

    <path d="M85 83.5V102C85 104.209 83.2091 106 81 106H62" stroke="white" strokeLinecap="round" />

    <path d="M85 23.5V5C85 2.79086 83.2091 1 81 1H62" stroke="white" strokeLinecap="round" />

    <defs>
      <linearGradient
        id="paint0_linear_79_91723"
        x1="43"
        y1="50"
        x2="43"
        y2="74"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default JDParse;
